module.exports = __webpack_public_path__ + "img/05.973920a5.png";